import * as Yup from "yup";

const REQUIRED_MSG = "Required *";

/** Keep in sync with validation — used for modal highlighting */
export const ORDER_EDIT_REQUIRED_FIELDS = [
  "shipToAddress1",
  "shipToCity",
  "shipToState",
  "shipToPostalCode",
  "shipToCountry",
  "billToAddress1",
  "billToCity",
  "billToState",
  "billToPostalCode",
  "billToCountry",
];

const requiredShape = ORDER_EDIT_REQUIRED_FIELDS.reduce((acc, key) => {
  acc[key] = Yup.string().required(REQUIRED_MSG);
  return acc;
}, {});

export const orderValidationSchema = Yup.object().shape(requiredShape);
